import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';

@Component({
  selector: 'app-roster-trip-counts',
  templateUrl: './roster-trip-counts.component.html',
  styleUrls: ['./roster-trip-counts.component.css']
})
export class RosterTripCountsComponent implements OnInit {

  constructor(
    private dateAdapter: DateAdapter<Date>,
    public com: CommonServices,
    public excel: ExcelExportService,
    public api: ApiService,
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.filterFormsLoad();
    this.rosterTripCountAPI({
      default: true,
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
    })
  }
  public filterFormGrp: FormGroup;
  public todayDate: any = new Date;
  public isAssigned: any = '';
  // Table Variables
  public tableData: any = [];
  public tableHeaders: any = ['#', 'Reg no', 'Route name', 'Shift time', 'Transit mode', 'Distance travel (km)', 'Duration (in HH:MM:SS)', 'Max speed (km/h)'];
  public vehTripInfo: any = '';
  public excelData: any = [];
  public responseData: any = [];
  public noDataFoundEnable: boolean = false;
  matFormSize = '13px';

  // Filter Area
  public getTranMode: any = ''


  filterFormsLoad() {
    // Get Previous Day
    this.todayDate = new Date()
    const previousDay = new Date(this.todayDate.getTime());
    previousDay.setDate(this.todayDate.getDate() - 1);
    // Load the forms
    this.filterFormGrp = new FormGroup({
      tripDate: new FormControl(previousDay),
      transitMode: new FormControl(''),
    })
  }

  fieldChange(e: any, fieldType) {
    let value = e.value;
    if (fieldType == 'transitMode') {
      this.getTranMode = value;
    }
  }
  exportFunction() {
    let obj = {}
    obj['default'] = true;
    if (obj['tripDate'] != '') obj['tripDate'] = new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    if (this.filterFormGrp.valid) {
      this.rosterTripCountAPI(obj);
    }
  }

  filterFuntionalityArea() {
    if (this.getTranMode != '') {
      let arr = this.responseData.filter(e => e['transitMode'] == this.getTranMode)
      this.tableData = arr;
      if (this.tableData.length <= 0) {
        this.noDataFoundEnable = true
      }
    }
  }

  rosterTripCountAPI(obj: any) {
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res.status == 'success' && res['data'].length > 0) {
          this.tableData = res['data'];
          this.responseData = res['data'];
          this.filterFuntionalityArea();
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  async exportToExcel() {
    this.excelData = {};
    let data = [];
    let serialNo = 1; 

    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];
      this.getTranMode = this.getTranMode != '' ? this.getTranMode : 'Both';
      // this.getVendorName = (this.getVendorName === null) ? this.getVendorName = 'Temporary' : this.getVendorName;
      if (item && item['vehRegNo'] && item['vehRegNo'] != null) {
        try {
        
          for (let j = 0; j < item.empInfo.length; j++) {
            let emp = item.empInfo[j];
            let res = {
              value: [
                serialNo++,  
                item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
                item.title && item.title ? this.com.convertTitleCase(item?.title) : '---',
                item.transitMode ? this.com.convertTitleCase(item.transitMode) : '---',
                emp.name ? this.com.convertTitleCase(emp.name) : '---',
                emp.empRefID ? this.com.convertTitleCase(emp.empRefID) : '---',
                emp.gender ? this.com.convertTitleCase(emp.gender) : '---',
                (emp.board == true) ? 'Present' : 'Absent',
                emp.attenTime ? emp.attenTime : '---', 
                item.branchInfo.name  ? this.com.convertTitleCase(item.branchInfo.name) : '---',
                item.shiftTimeStr ? item.shiftTimeStr : '---',               
                item.tripStartTime ?   item.tripStartTime : '---',
                item.tripEndTime ?   item.tripEndTime : '---',
                item.tripsheetID ? item.tripsheetID : '---',
                (item.driverInfo && item.driverInfo.name )? item.driverInfo.name : '---',
                (item.driverInfo && item.driverInfo.number )? item.driverInfo.number : '---', 
                (item.vehTripInfo && item.vehTripInfo.maxSpeed) ? item.vehTripInfo.maxSpeed : '---',
                (item.vehTripInfo && item.vehTripInfo.dist) ? item.vehTripInfo.dist : '---',
                (item.vehTripInfo && item.vehTripInfo.timeDuration) ? item.vehTripInfo.timeDuration : '---',
                item.tripType ?  item.tripType : '---',
                item.vehType ? item.vehType : '---',
                (item.escort && item.escort.name) ? item.escort.name : '---',
                (item.escort && item.escort.number) ? item.escort.number : '---',
              ],

              border: {
                right: { style: 'thin' }, bottom: { style: 'thin' },
              },
            }
            data.push(res);
          }

          // let res = {
          //   value: [
          //     i + 1,
          //     item.vehRegNo && item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
          //     item.title && item.title ? this.com.convertTitleCase(item.title) : '---',
          //     item.shiftTimeStr && item.shiftTimeStr ? item.shiftTimeStr : '---',
          //     item.transitMode && item.transitMode ? this.com.convertTitleCase(item.transitMode) : '---',
          //     (item.vehTripInfo && item.vehTripInfo.dist) ? (item.vehTripInfo && item.vehTripInfo.dist) : '---',
          //     (item.vehTripInfo && item.vehTripInfo.timeDuration) ? (item.vehTripInfo && item.vehTripInfo.timeDuration) : '---',
          //     (item.vehTripInfo && item.vehTripInfo.maxSpeed) ? (item.vehTripInfo && item.vehTripInfo.maxSpeed) : '---',
          //   ],
          //   border: {
          //     right: { style: 'thin' }, bottom: { style: 'thin' },
          //   },
          // }
          // data.push(res);
          
        } catch (err) {
          console.log(err);
        }
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'W';
      let customizedData = [];
      let titleRow = {
        value: ['Roster Trip Count'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = rowCount + 2;
      let subtitleRow = {
        value: [
          "Trip Date          : " + this.com.timestampToDate(new Date(this.filterFormGrp.value.tripDate).getTime(), 'DMY') + "\n" +
          "Transit Mode       : " + this.getTranMode + ""
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        border: { right: { style: 'thin' } },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Reg no', 'Shift name', 'Transit mode', 'Employee name','Employee id','Gender','Attendance','Attendance time','Branch', 'Shift time', 'Trip start time','Trip end time','Trip sheet Id ','Driver name','Driver mobile', 'Max speed (km/h)', 'Distance travel (km)','Duration (in HH:MM:SS)','Trip type (Ac/non ac)', 'Vehicle type','Escort name','Escort Mobile'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Roster Trip Count'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 20 }, { colNo: 4, width: 20 }, { colNo: 5, width: 20 }, { colNo: 6, width: 30 }, { colNo: 7, width: 30 }, { colNo: 8, width: 30 }, { colNo: 9, width: 30 },{ colNo: 10, width: 40 },{ colNo: 11, width: 40 },{ colNo: 12, width: 40 },{ colNo: 13, width: 40 },{ colNo: 14, width: 40 },{ colNo: 15, width: 40 },{ colNo: 16, width: 40 },{ colNo: 17
             , width: 40 },{ colNo: 18, width: 40 },{ colNo: 19, width: 40 },{ colNo: 20, width: 40 },{ colNo: 21, width: 40 },{ colNo: 22, width: 40 },{ colNo: 23, width: 40 }],
        }
      }
      this.downloadExlReport();
    }
  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Roster Trip Count' + new Date().getTime() + '.xlsx');
  }
}
